import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MessageCircle, Phone, Trash2 } from "lucide-react";
import { api, errorText } from "@/lib/api";

const digits = (p) => (p || "").replace(/[^\d]/g, "");
const fmt = (iso) => new Date(iso).toLocaleString("pl-PL", { dateStyle: "medium", timeStyle: "short" });

const QuoteCard = ({ q, onDelete }) => (
  <article data-testid={`admin-quote-${q.id}`} className="rounded-2xl border border-white/10 bg-[#14171E] p-6">
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <p className="font-display text-2xl font-bold italic">{q.route_from || "?"} → {q.route_to || "?"}</p>
        <p className="mt-1 text-sm text-zinc-400">{fmt(q.created_at)} · {q.name || "bez imienia"} · {q.lang?.toUpperCase()}</p>
      </div>
      <button data-testid={`admin-quote-delete-${q.id}`} onClick={() => onDelete(q.id)} className="rounded-full border border-white/15 p-2 text-zinc-400 hover:border-red-400 hover:text-red-400" aria-label="Usuń">
        <Trash2 className="h-4 w-4" />
      </button>
    </div>
    <p className="mt-4 whitespace-pre-wrap text-zinc-200">{q.message}</p>
    <div className="mt-5 flex flex-wrap gap-2">
      <a data-testid={`admin-quote-call-${q.id}`} href={`tel:${q.phone}`} className="flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-semibold text-black hover:bg-zinc-300">
        <Phone className="h-4 w-4" /> {q.phone}
      </a>
      <a data-testid={`admin-quote-wa-${q.id}`} href={`https://wa.me/${digits(q.phone)}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-sm hover:bg-white hover:text-black">
        <MessageCircle className="h-4 w-4" /> WhatsApp
      </a>
    </div>
  </article>
);

export default function QuotesList() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/admin/quotes").then((r) => setItems(Array.isArray(r.data) ? r.data : [])).catch((e) => { setItems([]); toast.error(errorText(e)); });
  }, []);

  const remove = async (id) => {
    if (!window.confirm("Usunąć to zapytanie?")) return;
    try {
      await api.delete(`/admin/quotes/${id}`);
      setItems((l) => l.filter((q) => q.id !== id));
    } catch (e) {
      toast.error(errorText(e));
    }
  };

  if (items === null) return <p className="text-zinc-400">Ładowanie…</p>;
  return (
    <section data-testid="admin-quotes-list" className="space-y-4">
      <p className="text-sm text-zinc-400">Zapytań: {items.length}. Każde nowe przychodzi też mailem na contact@transcars.eu.</p>
      {items.length === 0 && <p data-testid="admin-quotes-empty" className="rounded-2xl border border-dashed border-white/15 p-10 text-center text-zinc-400">Brak zapytań.</p>}
      {items.map((q) => <QuoteCard key={q.id} q={q} onDelete={remove} />)}
    </section>
  );
}
